import * as types from '../types'

const init = {
    pageNo: 1,
    end: null,
    list: [
        
    ]
}

const past = (state = init, action) => {
    switch(action.type) {
        case types.COST_HANDLE: {
            const {
                data: {
                    list,
                    pageBean
                }
            } = action;
            const newState = {...state}
            newState.list = newState.list.concat(list);
            newState.pageNo++;
            newState.end = pageBean.end;
            newState.list.map(it => {
                it.price = it.countNumber > 0? `+${it.countNumber}`: it.countNumber;
                //it.orderDate = 1617865347000
                it.time = it.orderDate? new Date(it.orderDate).format('yyyy.M.d hh:mm:ss'): null;
            })
            console.log(newState)
            return newState;
        };
        default:
            return state;
    }
}


export default past;